import { Component, OnInit } from '@angular/core';
import { Platform, NavController, NavParams, Events } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { SavoirPlusComponent } from '../savoir-plus/savoir-plus';
import { ConnexionComponent } from '../connexion/connexion';

@Component({
  selector: 'page-rapport-sans-acces',
  templateUrl: 'rapport-sans-acces.html'
})
export class RapportSansAccesComponent implements OnInit {
    lastScans: any;

    constructor(
        private platform: Platform,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private navParams: NavParams,
        private events: Events
    ) {
        this.platform.ready().then(() => {
            this.ga.trackView("Rapport sans accès");
        });
    }

    ngOnInit() {
        this.lastScans = this.navParams.get("data").data || { qrCode: "" };
        this.events.publish('scanSansRapport:qrCode', this.lastScans.qrCode);
    }

    goToPage(page: string): any {
        this.events.unsubscribe(
            'scanSansRapport:qrCode', (qrCode: any) => {}
        );
        if (page === 'savoir-plus') {
            this.navCtrl.push(SavoirPlusComponent);
        } else if (page === 'connexion') {
            this.navCtrl.push(ConnexionComponent, { qrCode: this.lastScans.qrCode });
        }
    }

    callNumber(): any {
        window.location.href = "tel: 0800802402";
    }
}



// WEBPACK FOOTER //
// ./src/pages/rapport-sans-acces/rapport-sans-acces.ts